import { render, staticRenderFns } from "./staffYawp.vue?vue&type=template&id=4472dabc"
import script from "./staffYawp.vue?vue&type=script&lang=js"
export * from "./staffYawp.vue?vue&type=script&lang=js"
import style0 from "./staffYawp.vue?vue&type=style&index=0&id=4472dabc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports